export const FETCH_TIMER_STATE = 'FETCH_TIMER_STATE';
export const START_TIMER = 'START_TIMER';
export const STOP_TIMER = 'STOP_TIMER';
export const TOGGLE_TIMER = 'TOGGLE_TIMER';
export const CLOCK_IN_MODAL_CLOSE = 'CLOCK_IN_MODAL_CLOSE';
export const SET_TIME_TRACKING_BARBERS = 'SET_TIME_TRACKING_BARBERS';
export const UPDATE_BARBER_TIME_TRACKING = 'UPDATE_BARBER_TIME_TRACKING';
export const REMOVE_BARBER_TIME_TRACKING = 'REMOVE_BARBER_TIME_TRACKING';
export const ADD_BARBER_TRACK_TIME = 'ADD_BARBER_TRACK_TIME';
export const SYNC_BARBER_TRACK_TIME = 'SYNC_BARBER_TRACK_TIME';
